import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BotService } from "../../services/BotService";
import { FlowsService } from "../../services/FlowsServices";
import { useCurrentAccount } from "../../hooks/useCurrentAccount";
import { BOT_STATUS } from "../../constants";
import { useTranslation } from "react-i18next";
import useTokenApi from "../../hooks/useTokenApi";
import useRequest from "../../hooks/useRequest";
import AddFlowModal from "../../pages/flows/FlowPartial";
import Aside from "../../components/Aside"
import CustomDataTable from "../../components/CustomDataTable"
import Footer from "../../components/Footer"
import Header from "../../components/Header"
import Swal from 'sweetalert2'
import { AlertService } from "../../services/Alert";

function FlowsPage() {
    const { t } = useTranslation();
    const { call, isRequesting } = useRequest();
    const [showModalAdd, setShowModalAdd] = useState(false)
    const { account } = useCurrentAccount();
    const columns = [
        {
            name: 'ID',
            sortable: false,
            center: true,
            selector:(row: any) => row._id,

        },
        {
            name: t('campaigns.response-flow.name-flow'),
            sortable: true,
            center: true,
            selector: (row: any) => row.name,
        },
        {
            name: t("platform.chatbot.status"),
            sortable: true,
            center: true,
            cell: (row: any) => {
                let badgeContent;

                switch (row.status) {
                    case BOT_STATUS.ACTIVE:
                        badgeContent = (
                            <span className="badge bg-soft-info text-info">
                                <i className="bi bi-check-circle-fill fs-6"></i>
                                <span className="fs-6 ms-1">{t("platform.chatbot.active")}</span>
                            </span>
                        );
                        break;
                    case BOT_STATUS.INACTIVE:
                        badgeContent = (
                            <span className="badge bg-soft-danger text-danger">
                                <i className="bi bi-x-circle-fill fs-6"></i>
                                <span className="fs-6 ms-1">{t("platform.chatbot.inactive")}</span>
                            </span>
                        );
                        break;
                    case BOT_STATUS.NOT_SHOW:
                        badgeContent = (
                            <span className="badge bg-soft-success text-success">
                                <i className="bi bi-dash-circle-fill fs-6"></i>
                                <span className="fs-6 ms-1">{t("platform.chatbot.no-config")}</span>
                            </span>
                        );
                        break;
                    default:
                        badgeContent = (
                            <span className="badge bg-soft-success text-success">
                                <i className="bi bi-dash-circle-fill fs-6"></i>
                                <span className="fs-6 ms-1">{t("platform.chatbot.no-config")}</span>
                            </span>
                        );
                        break;
                }

                return <p className="text-nowrap mb-0">{badgeContent}</p>;
            }
        },
        {
            name: t("platform.chatbot.actions"),
            sortable: false,
            center: true,
            cell: (row: any) => {
                return (
                    <>
                        {
                            row.status === 'not_show' && (
                                <button className="btn btn-white btn-sm" onClick={() => registerBot(row.account_id)}>
                                    {t("platform.chatbot.enable")}
                                </button>
                            )
                        }

                        {(row.status === BOT_STATUS.INACTIVE || row.status === BOT_STATUS.ACTIVE) &&
                            <div className="btn-group" role="group">
                                <button className="btn btn-white btn-sm" onClick={() => navigate(`/campaigns/builder`, { state: { account_id: row.account_id, status_flow: row.status, name_flow: row.name, bot: row._id } })}>
                                    <i className="bi-gear-wide-connected me-1 text-primary fw-bolder"></i> {t("config-text")}
                                </button>
                                <div className="btn-group">
                                    <button title="title" type="button" className="btn btn-white btn-icon btn-sm dropdown-toggle dropdown-toggle-empty" data-bs-toggle="dropdown" aria-expanded="false"></button>

                                    <div className="dropdown-menu dropdown-menu-end mt-1" >
                                        {
                                            row.status === BOT_STATUS.INACTIVE && <button className="dropdown-item" onClick={() => chanceStatus(row)}><i className="bi bi-shield-check me-3 fs-4 text-info fw-bolder"></i>{t("platform.chatbot.enable")} </button>
                                        }
                                        {
                                            row.status === BOT_STATUS.ACTIVE && <button className="dropdown-item" onClick={() => chanceStatus(row)}><i className="bi bi-shield-slash me-3 fs-4 text-danger fw-bolder"></i>{t("platform.chatbot.disable")} </button>
                                        }
                                        {row.version !== '3.0' && (
                                            <button className="dropdown-item" onClick={() => updagradaBot(row.account_id)}>
                                                <i className="bi bi-stars me-3 fs-4 fw-bolder text-primary"></i> {t("platform.chatbot.update")}
                                            </button>
                                        )}
                                    </div>
                                </div>

                            </div>
                        }
                    </>

                )
            }
        },
    ];

    const navigate = useNavigate();
    const { tokenApi } = useTokenApi();
    const [rows, setRows] = useState([])
    const [accountsSelected, setAccountsSelected] = useState([])

    const chanceStatus = async (account: any) => {
        const { isConfirmed } = await Swal.fire({
            title: account.status === BOT_STATUS.ACTIVE ? t('campaigns.response-flow.disable-flow') : t('campaigns.response-flow.enable-flow'),
            text: `${t('campaigns.response-flow.change-status-text-1')} ${account.status === BOT_STATUS.ACTIVE ? t('campaigns.response-flow.disable') : t('campaigns.response-flow.enable')} ${t('campaigns.response-flow.change-status-text-2')}`,
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: t('btn-continue'),
            cancelButtonText: t('btn-cancel'),
            customClass: {
                cancelButton: 'btn btn-white',
                confirmButton: 'btn btn-primary me-3',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.setStatus({
                    token: tokenApi,
                    bot_id: account._id,
                    status: account.status === BOT_STATUS.ACTIVE ? BOT_STATUS.INACTIVE : BOT_STATUS.ACTIVE
                })

                await getFlows();
            }
        })

        if (isConfirmed) {
            AlertService.toastSuccess(t('campaigns.response-flow.changed-status-title') +' '+ t('campaigns.response-flow.changed-status-text'))
        }
    }

    const updagradaBot = async (account_id: number) => {
        const { isConfirmed } = await Swal.fire({
            title: t('campaigns.response-flow.update-flow'),
            text: t('campaigns.response-flow.update-flow-text'),
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: t('btn-continue'),
            cancelButtonText: t('btn-cancel'),
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.register({
                    token: tokenApi,
                    account_id: account_id,
                    subaccount_id: null
                })

                await getFlows();
            }
        })

        if (isConfirmed) {
            AlertService.toastSuccess(t('campaigns.response-flow.changed-status-title')+' '+ t('campaigns.response-flow.update-successful'))
        }
    }

    const registerBot = async (account_id: number) => {
        const { isConfirmed } = await Swal.fire({
            title: t('campaigns.response-flow.enable-chatbot'),
            text: t('campaigns.response-flow.enable-chatbot-text'),
            icon: 'warning',
            iconColor: '#f5ca99',
            confirmButtonText: t('btn-continue'),
            cancelButtonText: t('btn-cancel'),
            customClass: {
                cancelButton: 'btn btn-white order-1  me-3',
                confirmButton: 'btn btn-primary order-2',
            },
            buttonsStyling: false,
            showConfirmButton: true,
            focusDeny: true,
            focusCancel: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                await BotService.register({
                    token: tokenApi,
                    account_id: account_id,
                    subaccount_id: null
                })

                await getFlows();
            }
        })

        if (isConfirmed) {
            AlertService.toastSuccess(t('campaigns.response-flow.changed-status-title') +' '+ t('campaigns.response-flow.enable-successful'))
        }
    }

    const handleCloseLinkModal = async (refresh: any) => {
        if (refresh) {
            await getFlows();
        }
        setShowModalAdd(false)
    }

    const getFlows = async () => {
        const { data } = await call(() => FlowsService.getFlows(account.id));
        setRows(data)
    }

    useEffect(() => {
        getFlows();
    }, [])


    return (
        <>
            <Header />
            <Aside />

            <main id="content" role="main" className="main">

                <div className="content container-fluid" >

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t('campaigns.monitoring.breadcrumb-campaigns')}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.chatbot.chatbot-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page"></li>
                                    </ol>
                                </nav>
                                <h1 className="page-header-title"><i className="bi-share nav-icon"></i>{t('campaigns.response-flow.page')}</h1>
                            </div>
                            <div className="col-sm-auto">
                                <button type="button" className="btn btn-primary btn-sm" onClick={() => setShowModalAdd(true)} ><i className="bi-share-fill me-1"></i> {t('campaigns.response-flow.add-flow')}</button>
                            </div>
                        </div>

                    </div>

                    <div className="row">
                        <div className="col-sm-12">
                            <CustomDataTable
                                showExport={false}
                                columns={columns}
                                isLoading={isRequesting}
                                data={rows.filter(row => accountsSelected && accountsSelected.length ? accountsSelected.find(a => a.label === row.name) : true)}
                                filter={(row, term) => {
                                    if (!term) return true;

                                    return (
                                        `${row.name}`.match(new RegExp(`${term}`, 'i')) ||
                                        `${row._id}`.match(new RegExp(`${term}`, 'i'))
                                    )
                                }}
                                hideAccountsFilter={true}
                            />
                        </div>

                    </div>
                </div>
                < AddFlowModal
                    showModalLink={showModalAdd}
                    onRequestClose={handleCloseLinkModal}
                />
                <Footer />
            </main>
        </>
    )
}
export default FlowsPage